// ./cmp/ProductWrapper.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Product from "./product"; // your existing product component
import { doc, getDoc } from "firebase/firestore";
import { db1 } from "./firebase/firebase1";

export default function ProductWrapper() {
  const { id } = useParams();
  const history = useNavigate();
  const [product, setProduct] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    let mounted = true;

    const fetchProduct = async () => {
      try {
        const docRef = doc(db1, "our_products", id);
        const docSnap = await getDoc(docRef);

        if (!mounted) return;

        if (docSnap.exists()) {
          const found = docSnap.data();
          const normalized = {
            id,
            ...found,
            images: found.images && found.images.length
              ? found.images
              : found.image
                ? [found.image]
                : [],
            variants: found.variants && found.variants.length
              ? found.variants
              : [
                {
                  id: "default",
                  label: "Default",
                  price:
                    typeof found.price === "number" ? found.price : 0,
                  mrp:
                    typeof found.mrp === "number"
                      ? found.mrp
                      : typeof found.price === "number"
                        ? found.price
                        : 0,
                  stock:
                    typeof found.stock === "number" ? found.stock : 0,
                },
              ],
          };

          console.log('product: '+JSON.stringify(normalized));
          setProduct(normalized);
        } else {
          setProduct(null);
          console.log('null product');
        }
      } catch (error) {
        console.error("Error fetching product:", error);
        setProduct(null);
      }
    };

    fetchProduct();

    return () => {
      mounted = false;
    };
  }, [id]);


  // still loading
  if (product === undefined) {
    return <div style={{ padding: 28 }}>Loading product…</div>;
  }

  // not found
  if (product === null) {
    return (
      <main style={{ width: "min(1100px, 94%)", margin: "28px auto", padding: 20 }}>
        <h2>Product not found</h2>
        <p>
          The product you requested could not be found.{" "}
          <button onClick={() => history("/")}>Go home</button>
        </p>
      </main>
    );
  }

  // ✅ render only when product exists and is valid
  if (!product || typeof product !== "object") {
    return <div style={{ padding: 28 }}>Loading product…</div>;
  }

  // ✅ double safety: ensure product.variants is at least an array
  const safeProduct = {
    ...product,
    variants: Array.isArray(product.variants)
      ? product.variants
      : [
        {
          id: "default",
          label: "Default",
          price: product.price || 0,
          mrp: product.mrp || product.price || 0,
          stock: product.stock || 0,
        },
      ],
  };

  return <Product product={safeProduct} />;

}
